<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";

/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, RightBar, Footer },
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null || null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      isMenuCondensed: false,
      logo: require("@/assets/images/go_shops.svg"),
      logo_small: require("@/assets/images/go_shops_small.svg"),
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      // Un solo hook a la vez: antes se sumaba uno por click y, con el layout
      // persistente, se acumularían toda la sesión.
      if (this.removeMenuReset) this.removeMenuReset();
      if (window.screen.width >= 992) {
        this.removeMenuReset = router.afterEach(() => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        this.removeMenuReset = router.afterEach(() => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    reloadMenu(){
      this.$refs.sideBarComponent.reloadMenu();
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    changeLogo(route){
      if(route.meta && route.meta.product){

        switch(route.meta.product) {
          case 'live':
            this.logo = require("@/assets/images/go_live_shop.svg");
            this.logo_small = require("@/assets/images/go_live_shop_small.svg");
            break;
          case 'search':
            this.logo = require("@/assets/images/go_search.svg");
            this.logo_small = require("@/assets/images/go_search_small.svg");
            break;
          case 'reco':
            this.logo = require("@/assets/images/go_reco.svg");
            this.logo_small = require("@/assets/images/go_reco_small.svg");
            break;
        }
      }
      else{
        this.logo = require("@/assets/images/go_shops.svg");
        this.logo_small = require("@/assets/images/go_shops_small.svg");
      }

      
    }
    
  },
  beforeDestroy() {
    if (this.removeMenuReset) this.removeMenuReset();
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },

  
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <NavBar :logo="logo" :logo_small="logo_small"/>
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" ref="sideBarComponent" />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer  v-if="false"/>
      </div>
      <RightBar />
    </div>
  </div>
</template>
